export default __webpack_public_path__ + "static/media/ActiveWear.b90f9f23.svg";